import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AuditModal } from "../../../components/AuditTrail/AuditModal";
import { ExpandableContent } from "../../../components/CustomControls/ExpandableContent";
import { AdverseEvents } from "../../../components/MedicalRecords/AdverseEvents";
import { AuditTrail } from "../../Admin/AuditTrail";
import { useConditions } from "../Hooks/useConditions";
import { useAdverseEventHistoryByConcept } from "../Hooks/useAdverseEvents";
import { ModalConceptHistory } from "../Modals/ModalConceptHistory";

export const ConditionsListContainer = ({ mrn, medicalRecordNumber, entryId, actual, chronic, title, expandedAll }) => {
    const { t } = useTranslation();
    const [data, query, totalSize, isLoading, handleTableChange, , setSearchTerm] = useConditions(medicalRecordNumber, entryId, null ,actual, chronic);

    const [modal, setModal] = useState(null);
    const handleAuditTrail = (entityId) => {
        setModal(
            <AuditModal
                onClose={() => { setModal(null); }}
                title={t("auditTrail.audit")}
            >
                <AuditTrail entity="AdverseEvents" entityId={entityId} medicalRecordNumber={medicalRecordNumber} />
            </AuditModal>
        )
    }
    const handleHistoryByConcept = (conceptId, _mrn) => {
        setModal(<ModalConceptHistory
            onClose={() => { setModal(null); }}
            title={t("medicalRecords.history.byConcept")}
            medicalRecordNumber={medicalRecordNumber || mrn}
            conceptId={conceptId}
            useHistoryHook={useAdverseEventHistoryByConcept}
            getConceptName={(row) => row.adverseEffect}
            getCycleSubtitle={(row) => row.intensity || ''}
        />)
    }

    const _title = title ?? t("medicalRecords.condition.title");
    if (entryId && totalSize === 0)
        return null;
        
    return (
        <ExpandableContent title={_title} content="adverseEvents" expandedAll={expandedAll}>
            {modal}
            <AdverseEvents
                withCard={false}
                data={data}
                query={query}
                totalSize={totalSize}
                isLoading={isLoading}
                onTableChange={handleTableChange}
                onAuditTrail={handleAuditTrail}
                onHistoryByConcept={handleHistoryByConcept}
                onSearchTermChange={setSearchTerm}
            />
        </ExpandableContent>
    );
}